import PropTypes from 'prop-types';
import React from 'react';

function InfoSolid(props) {
  const { fill } = props;

  return (
    <svg height="24" style={{ fill }} viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M2.43311 11.9985C2.43311 14.4849 3.42083 16.8695 5.17898 18.6277C6.93713 20.3858 9.3217 21.3735 11.8081 21.3735C14.2945 21.3735 16.6791 20.3858 18.4372 18.6277C20.1954 16.8695 21.1831 14.4849 21.1831 11.9985C21.1831 9.51213 20.1954 7.12756 18.4372 5.36941C16.6791 3.61126 14.2945 2.62354 11.8081 2.62354C9.3217 2.62354 6.93713 3.61126 5.17898 5.36941C3.42083 7.12756 2.43311 9.51213 2.43311 11.9985ZM9.93311 10.7485C9.93311 10.4034 10.2129 10.1235 10.5581 10.1235H11.1831C11.5146 10.1235 11.8326 10.2552 12.067 10.4897C12.3014 10.7241 12.4331 11.042 12.4331 11.3735V14.4985C12.4331 14.6643 12.499 14.8233 12.6162 14.9405C12.7334 15.0577 12.8923 15.1235 13.0581 15.1235H13.6831C14.0283 15.1235 14.3081 15.4034 14.3081 15.7485C14.3081 16.0937 14.0283 16.3735 13.6831 16.3735H13.0581C12.5608 16.3735 12.0839 16.176 11.7323 15.8244C11.3806 15.4727 11.1831 14.9958 11.1831 14.4985V11.3735H10.5581C10.2129 11.3735 9.93311 11.0937 9.93311 10.7485ZM10.9026 7.05129C11.0793 6.93316 11.2872 6.87012 11.4998 6.87012C11.7849 6.87012 12.0583 6.98338 12.2599 7.18498C12.4615 7.38658 12.5748 7.66001 12.5748 7.94512C12.5748 8.15773 12.5118 8.36558 12.3936 8.54236C12.2755 8.71914 12.1076 8.85692 11.9112 8.93829C11.7148 9.01965 11.4986 9.04094 11.2901 8.99946C11.0816 8.95798 10.89 8.8556 10.7397 8.70526C10.5893 8.55492 10.4869 8.36337 10.4455 8.15484C10.404 7.94631 10.4253 7.73016 10.5066 7.53373C10.588 7.3373 10.7258 7.16941 10.9026 7.05129Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

InfoSolid.propTypes = {
  fill: PropTypes.string.isRequired
};

export default InfoSolid;
